// @flow

import styled from "styled-components";

const StepsWrapper = styled.div`
    padding: 20px 0;
    width: 100%;
`;

export default StepsWrapper;



// WEBPACK FOOTER //
// ./src/containers/Assessment/Sidebar/components/StepsWrapper.jsx